import React from "react";
import { useNavigate } from "react-router-dom";
import CommonModal from "../CommonModal";
import Button from "../../Elements/Button";

// Nudge, not a block: ignoring this just means new sessions stop getting location data
// until the account has its own provider -- everything else keeps working, so (unlike
// the first-run profile modal) this is a normal, closable dialog.
const FallbackLimitModal = ({ show, onClose }) => {
  const navigate = useNavigate();

  const goToIntegrations = () => {
    onClose();
    navigate("/profile#geo-provider-section");
  };

  return (
    <CommonModal
      title="Location Tracking Limit Reached"
      modalStatus={show}
      changeActiveStatus={onClose}
      footer={
        <Button
          classList="success"
          addonClass="my-2 mx-2"
          text="Sign Up"
          onClick={goToIntegrations}
        />
      }
      centered
    >
      <p className="p-1">
        To continue to use location tracking in this account, please click here to sign up for a free account.
      </p>
    </CommonModal>
  );
};

export default FallbackLimitModal;
